import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import ModalHelp from '../../../components/ModalHelp';

interface AlterarStatusBancaModalProps {
    show: boolean;
    handleClose: () => void;
    handleConfirm: (status: string) => void;
    statusAtual: string;
}

const statusOptions = [
    { value: 'INDEFINIDA', label: 'Indefinida' },
    { value: 'PLANEJADA', label: 'Planejada' },
    { value: 'CONSULTADA', label: 'Consultada' },
    { value: 'DISPONIBILIDADE', label: 'Disponibilidade' },
    { value: 'DEFINIDA', label: 'Definida' },
    { value: 'CONVOCADA', label: 'Convocada' },
    { value: 'INTEGRACAO', label: 'Integração' },
    { value: 'FINALIZADA', label: 'Finalizada' },
    { value: 'CANCELADA', label: 'Cancelada' },
    { value: 'FECHADA', label: 'Fechada' }
];

const AlterarStatusBancaModal: React.FC<AlterarStatusBancaModalProps> = ({
    show,
    handleClose,
    handleConfirm,
    statusAtual
}) => {
    const [status, setStatus] = useState<string>(statusAtual);

    useEffect(() => {
        setStatus(statusAtual);
    }, [statusAtual]);

    const handleSubmit = () => {
        if (status) {
            handleConfirm(status);
        }
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Alterar Status da Banca</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ModalHelp text="Altere manualmente o status da banca. Use com cautela — esta é uma ação administrativa que pode afetar o fluxo normal." />
                <Form.Group>
                    <Form.Label>Status</Form.Label>
                    <Form.Select 
                        value={status} 
                        onChange={(e) => setStatus(e.target.value)}
                    >
                        {statusOptions.map(option => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </Form.Select>
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Cancelar
                </Button>
                <Button 
                    variant="primary" 
                    onClick={handleSubmit}
                    disabled={!status}
                >
                    Confirmar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AlterarStatusBancaModal;
